/* eslint-disable camelcase */

export enum TYPE_OF_ENGAGEMENT {
  SPEAKER_ENGAGEMENT = 'speaker_engagement',
  IN_PERSON_WORKSHOP = 'in_person_workshop',
  CONSULTING_PROGRAM = 'consulting_program',
  HQ_PLUS = 'hq_plus',
}
